import { Component, OnInit, ViewEncapsulation, OnDestroy, ChangeDetectorRef, HostListener } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { CppPricingReportManageSubscription } from '../../../../services/cpp/cpp-pricing-report-manage-subscription.service';
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { MasterConstants } from './../../../../common/constants/master-constants';
import { ReportType } from '../../../../models/report-type.model';
import * as $ from 'jquery';

@Component({
  selector: 'app-cpp-ams-pricing-manage-subscription',
  templateUrl: './cpp-ams-pricing-manage-subscription.component.html',
  styleUrls: ['./cpp-ams-pricing-manage-subscription.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CppAmsPricingManageSubscriptionComponent implements OnInit, OnDestroy {
  private subscription = new Array<Subscription>();
  headerCompany = MasterConstants.US_COMPANYCODE;
  plManageSubColumns: string[] = ['reportName', 'status', 'updateUser', 'updateTimestamp'];
  plManageSubDataSource: MatTableDataSource<any>;
  userName: string = '';
  userId: string = '';
  userEmailId: string = '';

  constructor(private cppManageSubscription: CppPricingReportManageSubscription,
    private loaderService: LoaderService,
    private toastrService: ToastrService,
    private cd: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.plManageSubDataSource = new MatTableDataSource([]);
    this.getManageSubscriptionList();
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setPriceListTableHeight();
  }

  // Called after component's view is fully intialised
  ngAfterViewInit() {
    this.setPriceListTableHeight();
  }

  setPriceListTableHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.topSection').outerHeight() - 30;
      $('.priceListTable').css('max-height', templateHeight + 'px');
    }, 100);
  }

  // Get data for Manage subscription
  getManageSubscriptionList() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.cppManageSubscription.getManageSubscriptionList(ReportType.AMSPricing).subscribe((result: any) => {
      this.userName = result.userName;
      this.userId = result.userId;
      this.userEmailId = result.emailId;

      result.cppManageSubscriptionData.map(x => {
        x['reportOrder'] = x.reportName == 'ALL' ? 'A' : 'B';
      });

      result.cppManageSubscriptionData.sort((a, b) => a.reportOrder.localeCompare(b.reportOrder) || a.reportName.localeCompare(b.reportName));

      this.plManageSubDataSource = new MatTableDataSource(result.cppManageSubscriptionData);
      this.loaderService.setLoaderStatus(false);
    }, (error => {
      this.loaderService.setLoaderStatus(false);
    })));
  }

  // Save Subscribed or unscribed data
  addUpdateSubscription(status, subscriptionData) {
    this.loaderService.setLoaderStatus(true);
    var postData = {
      status: status,
      reportTypeId: subscriptionData.reportTypeId,
      userReportFilterId: subscriptionData.userReportFilterId
    };
    this.subscription.push(this.cppManageSubscription.addUpdateSubscription(postData).subscribe((result: any) => {
      if (result) {
        this.toastrService.success('Records saved successfully.');
        this.getManageSubscriptionList();
      } else {
        this.toastrService.error('Something went wrong!');
        this.loaderService.setLoaderStatus(false);
      }
    }, (error => {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('Something went wrong!');
    })));
  }

  public ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
